/**
 * 商品管理接口
 */
export default {
  // 运营单位-商品管理-商品发布-商品协议列表查询
  pes_queryAgreementList: {
    // mock: true,
    control: 'dyc/zone/agreement/commoditymgnt/operator/commodityquery/queryAgreementList'
  },
  // 商品中心单品管理列表查询
  com_getSkuManagementListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSkuManagementListQry'
  },
  // 商品中心商品编码导出
  com_dealDycUccSpuCodingexport: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/dealDycUccSpuCodingexport'
  },
  // 商品中心单品管理列表查询
  com_getSkuhasBeenapprovalList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSkuhasBeenapprovalList'
  },
  // 运营单位-商品管理-商品发布-商品协议明细列表查询
  pes_queryAgreementItemList: {
    // mock: true,
    control: 'dyc/zone/agreement/commoditymgnt/operator/commodityquery/queryAgreementItemList'
  },
  // 判断是否限制商品类型
  com_agreementMaterialRangeLimitationCheck: {
    // mock: true,
    control: 'dyc/zone/agreement/agreementMaterialRangeLimitationCheck'
  },
  // 商品池-商品类型列表查询
  com_queryCpCommodityTypeList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpCommodityTypeList'
  },
  // 商品池-商品类型列表查询(设置了限定物料范围)
  com_getAllSignedProductPage: {
    // mock: true,
    control: 'dyc/supplier/getAllSignedProductPage'
  },
  // 商品池-商品类型列表查询(新)
  com_querySupplierList: {
    // mock: true,
    control: 'dyc/zone/agreement/querySupplierList'
  },
  // 商品池-频道管理列表查询
  com_queryCpChannelList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpChannelList'
  },
  // 商品管理-协议商品管理-商品审批-编辑已审批
  arg_getSpuhasBeenapprovalList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSpuhasBeenapprovalList'
  },
  // 商品管理-协议商品管理-商品审批-编辑审批通过
  arg_dealAgrEditApproval: {
    // mock: true,
    control: 'dyc/zone/commodity/dealAgrEditApproval'
  },
  // 商品管理-无协议商品管理-商品审批-编辑审批通过
  unarg_dealSelfEditApproval: {
    // mock: true,
    control: 'dyc/selfrun/commodity/dealSelfEditApproval'
  },
  // 商品管理-协议商品管理-商品审批-上架审批通过
  arg_dealDycArgSkuOnapproval: {
    // mock: true,
    control: 'dyc/zone/commodity/dealDycArgSkuOnapproval'
  },
  // 商品管理-无协议商品管理-商品审批-上架审批通过
  unarg_dealDycUccSelfSkuOnapproval: {
    // mock: true,
    control: 'dyc/selfrun/commodity/dealDycUccSelfSkuOnapproval'
  },
  // 商品管理-协议商品管理-商品审批-上架审批情况
  dyc_getUccSkuApprovalprocessListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getUccSkuApprovalprocessListQry'
  },
  // 商品管理-协议商品管理-商品审批-流程图节点
  dyc_getProcNodeQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getProcNodeQry'
  },
  // 商品管理-协议商品管理-商品审批-下架审批通过
  arg_dealAgrOffShelf: {
    // mock: true,
    control: 'dyc/zone/commodity/dealAgrOffShelf'
  },
  // 商品管理-协议商品管理-商品审批-下架审批通过
  unarg_dealOffShelfApproval: {
    // mock: true,
    control: 'dyc/selfrun/commodity/dealOffShelfApproval'
  },
  // 商品管理-协议商品管理-商品审批-恢复审批通过
  arg_dealbackshelfforapproval: {
    // mock: true,
    control: 'dyc/zone/commodity/dealbackshelfforapproval'
  },
  // 商品管理-无协议商品管理-商品审批-恢复审批通过
  unarg_dealbackshelfforapproval: {
    // mock: true,
    control: 'dyc/selfrun/commodity/dealbackshelfforapproval'
  },
  // 商品管理-协议单品库存列表查询
  arg_getAgrIteminstockListQry: {
    // mock: true,
    control: 'dyc/zone/commodity/getAgrIteminstockListQry'
  },
  // 商品管理-协议单品库存批量修改导入
  dyc_dealbatchEdit: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealbatchEdit'
  },
  // 商品管理-无协议单品库存列表查询
  dyc_getSelfIteminstockListQry: {
    // mock: true,
    control: 'dyc/selfrun/commodity/getSelfIteminstockListQry'
  },
  // 商品管理-商品中心单品详情查询
  dyc_getSkuManagement: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSkuManagement'
  },
  // 商品管理-商品中心单品编辑详情查询
  dyc_getSkuEditDetailQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSkuEditDetailQry'
  },
  // 商品管理-协议单品库存修改库存
  arg_dealDycUccIteminstockEdit: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccIteminstockEdit'
  },
  // 商品管理-商品详情查询
  dyc_getSpumanagementdetails: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSpumanagementdetails'
  },
  // 商品管理-商品管理编辑详情查询
  dyc_getSpuEditDetailQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSpuEditDetailQry'
  },
  // 商品管理-商品管理商品详情中的单品分页查询
  dyc_getSpuDetailSkuList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSpuDetailSkuList'
  },
  // 商品池-频道管理新增
  com_addCpChannel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/addCpChannel'
  },
  // 商品池-频道管理删除
  com_deleteCpChannel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/deleteCpChannel'
  },
  // 商品池-频道已关联类目列表查询
  com_queryCpChannelRelatedCategoryList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpChannelRelatedCategoryList'
  },
  // 商品池-频道已关联类目列表查询
  com_removeCpChannelRelatedCategory: {
    // mock: true,
    control: 'dyc/busicommon/commodity/removeCpChannelRelatedCategory'
  },
  // 商品池-频道未关联类目列表查询
  com_queryCpChannelNotRelatedCategoryList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpChannelNotRelatedCategoryList'
  },
  // 商品池-频道增加频道关联商品池
  com_relateCpChannelCommodityPools: {
    // mock: true,
    control: 'dyc/busicommon/commodity/relateCpChannelCommodityPools'
  },
  // 商品池-频道修改频道关联商品池
  com_updateCpChannel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/updateCpChannel'
  },
  // 	商品池-频道解除关联类目
  com_queryCpChannelRelatedCommodityPoolsLis: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpChannelRelatedCommodityPoolsList'
  },
  // 商品池-频道解除关联商品池
  com_removeCpChannelRelatedCommodityPools: {
    // mock: true,
    control: 'dyc/busicommon/commodity/removeCpChannelRelatedCommodityPools'
  },
  // 商品池-频道关联类目
  com_relateCpChannelCategory: {
    // mock: true,
    control: 'dyc/busicommon/commodity/relateCpChannelCategory'
  },
  // 采购电商自营-商品类型新增
  pes_addGoodsType: {
    // mock: true,
    control: 'dyc/busicommon/commodity/addGoodsType'
  },
  // 品牌信息列表查询
  bra_queryMallBrandMappingList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryMallBrandMappingList'
  },
  // 品牌信息详情查询
  bra_qryBrandDetail: {
    // mock: true,
    control: 'dyc/busicommon/commodity/qryBrandDetail'
  },
  // 品牌信息新增
  bra_addMallBrand: {
    // mock: true,
    control: 'dyc/selfrun/commodity/addMallBrand'
  },
  // 品牌信息新增名称重复校验
  bra_verifyMallBrandExist: {
    // mock: true,
    control: 'dyc/busicommon/commodity/verifyMallBrandExist'
  },
  // 品牌信息新增名称重复校验
  bra_queryGoodsBrandList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryGoodsBrandList'
  },
  // 品牌信息删除
  bra_deleteMallBrand: {
    // mock: true,
    control: 'dyc/selfrun/commodity/deleteMallBrand'
  },
  // 品牌信息修改
  bra_updateMallBrand: {
    // mock: true,
    control: 'dyc/busicommon/commodity/updateMallBrand'
  },
  // 未关联商品品牌查询
  bra_qryNoMappingCommBrand: {
    // mock: true,
    control: 'dyc/busicommon/commodity/qryNoMappingCommBrand'
  },
  // 已关联商品品牌查询
  bra_qryMallBrandInfoDetail: {
    // mock: true,
    control: 'dyc/busicommon/commodity/qryMallBrandInfoDetail'
  },
  // 删除品牌映射关系
  bra_deleteMallCommMapping: {
    // mock: true,
    control: 'dyc/busicommon/commodity/deleteMallCommMapping'
  },
  // 修改品牌映射关系
  bra_updateMallCommBrandMapping: {
    // mock: true,
    control: 'dyc/busicommon/commodity/updateMallCommBrandMapping'
  },
  // 商品品牌映射关系
  bra_addMallCommBrandMapping: {
    // mock: true,
    control: 'dyc/busicommon/commodity/addMallCommBrandMapping'
  },
  // 物料列表查询
  com_queryMaterialsList: {
    // mock: true,
    control: 'dyc/mall/commodity/queryMaterialsList'
  },
  // 公用应用-商品类型待关联物料分类列表
  dyc_qryTypewaitRelmdm: {
    // mock: true,
    control: 'dyc/busicommon/commodity/qryTypewaitRelmdm'
  },
  // 物料状态批量更新
  com_DycUccBatchupdatematerialstatus: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccBatchupdatematerialstatus'
  },
  // 物料分类下拉框
  com_qeueryDropDownmdmSearch: {
    // mock: true,
    control: 'dyc/busicommon/commodity/qeueryDropDownmdmSearch'
  },
  // 物料搜索
  com_dealDycUccThematerialsearch: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccThematerialsearch'
  },
  // 物料分类新增
  com_DycUccMaterialAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccMaterialAdd'
  },
  // 物料分类修改
  com_dealDycUccMaterialEdit: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccMaterialEdit'
  },
  // 物料详情
  com_getDycUccMaterialdetailsQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getDycUccMaterialdetailsQry'
  },
  // 物料分类列表查询
  com_getDycUccThematerialclassificationQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getDycUccThematerialclassificationQry'
  },
  // 物料分类搜索列表查询
  com_dealDycUccMaterialclassificationsearch: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccMaterialclassificationsearch'
  },
  // 物料分类删除
  com_dealDycUccMaterialclassificationinbulkDel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccMaterialclassificationinbulkDel'
  },
  // 物料分类停用和启用
  com_dealDycMdmBatchDeactivate: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycMdmBatchDeactivate'
  },
  // 新增分类
  com_dealDycUccThematerialclassificationAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccThematerialclassificationAdd'
  },
  // 修改分类
  com_dealDycUccThematerialclassificationEdit: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccThematerialclassificationEdit'
  },
  // 采购电商自营-商品类型修改
  pes_modifyGoodsType: {
    // mock: true,
    control: 'dyc/busicommon/commodity/modifyGoodsType'
  },
  // 上级导购哦类目查询
  est_selectUpperCatalog: {
    // mock: true,
    control: 'dyc/estore/commodity/busi/upperCatalog/selectUpperCatalog'
  },
  // 商品中心前台类目查询
  dyc_getDycUccCategoryatthefrontdeskQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getDycUccCategoryatthefrontdeskQry'
  },
  // 商品中心前台类目搜索
  dyc_getUccCategoryatthefrontdeskSearch: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getUccCategoryatthefrontdeskSearch'
  },
  // 商品池-商品类目新增
  dyc_addCpCommodityCategory: {
    // mock: true,
    control: 'dyc/busicommon/commodity/addCpCommodityCategory'
  },
  // 商品类目删除
  dyc_deleteGoodsCategory: {
    // mock: true,
    control: 'dyc/busicommon/commodity/deleteGoodsCategory'
  },
  // 商品池-商品类目修改
  cnnc_updateCommodityPoolsCommodityCategory: {
    // mock: true,
    control: 'dyc/busicommon/commodity/updateCommodityPoolsCommodityCategory'
  },
  // 商品池-商品类目位置查询API
  cnnc_queryCatalogPosition: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCatalogPosition'
  },
  // 商品池-商品类目已关联商品类型列表查询
  cnnc_queryCpCommodityCategoryRelatedCommodityTypeList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpCommodityCategoryRelatedCommodityTypeList'
  },
  // 商品池-商品类目未关联商品类型列表查询
  cnnc_queryCpCommodityCategoryNotRelatedCommodityTypeList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpCommodityCategoryNotRelatedCommodityTypeList'
  },
  // 商品池-商品类目关联商品类型
  cnnc_relateCpCommodityCategoryCommodityType: {
    // mock: true,
    control: 'dyc/busicommon/commodity/relateCpCommodityCategoryCommodityType'
  },
  // 商品池-商品类目取消关联商品类型
  cnnc_removeCpCommodityCategoryRelatedCommodityType: {
    // mock: true,
    control: 'dyc/busicommon/commodity/removeCpCommodityCategoryRelatedCommodityType'
  },
  // 采购电商自营-商品属性组列表查询
  pesapp_queryGoodsAttrGroupList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryGoodsAttrGroupList'
  },
  // 采购电商自营-商品属性组新增
  pesapp_addGoodsAttrGroup: {
    // mock: true,
    control: 'dyc/busicommon/commodity/addGoodsAttrGroup'
  },
  // 采购电商自营-商品属性组修改
  pesapp_modifyGoodsAttrGroup: {
    // mock: true,
    control: 'dyc/busicommon/commodity/modifyGoodsAttrGroup'
  },
  // 采购电商自营-属性组删除
  dyc_dealSpuAttrGroup: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSpuAttrGroup'
  },
  // 商品属性组已关联属性列表
  cnnc_queryGoodsAttrGroupRelatedAttrList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryGoodsAttrGroupRelatedAttrList'
  },
  // 商品属性组未关联属性列表
  cnnc_queryGoodsAttrGroupNotRelatedAttrList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryGoodsAttrGroupNotRelatedAttrList'
  },
  // 商品属性关联新增API
  pesapp_addGoodsAttrRel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/addGoodsAttrRel'
  },
  // 商品属性删除
  dyc_dealSpuAttrDel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSpuAttrDel'
  },
  // 公用应用-移除属性组关联属性
  dyc_dealRemoveAttrGrouprelated: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealRemoveAttrGrouprelated'
  },
  // 物料分类,商品类型查询
  ucc_queryMaterialClassify: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryMaterialClassify'
  },
  // 获取商品编码
  dyc_dealDycUccCodegeneration: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccCodegeneration'
  },
  // 可投放商品池
  dyc_getDycUccDropSpuPoolQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getDycUccDropSpuPoolQry'
  },
  // 商品属性列表查询
  dyc_getAttributeListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getAttributeListQry'
  },
  // 商品中心计量单位查询
  dyc_getmeasureInfo: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/getmeasureInfo'
  },
  // 商品属性新增服务
  dyc_dealSpuAttributeAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSpuAttributeAdd'
  },
  // 商品属性修改
  dyc_dealSpuAttrUpdate: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSpuAttrUpdate'
  },
  // 商品属性值列表查询
  dyc_getAttributevaluesListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getAttributevaluesListQry'
  },
  // 商品属性值新增
  dyc_dealSpuAttributevaluesAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSpuAttributevaluesAdd'
  },
  // 商品属性值删除
  dyc_dealRemoveAttrValue: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealRemoveAttrValue'
  },
  // 商品池列表查询
  cnnc_queryCpCommodityPoolsList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpCommodityPoolsList'
  },
  // 商品池新增
  cnnc_addCpCommodityPools: {
    // mock: true,
    control: 'dyc/busicommon/commodity/addCpCommodityPools'
  },
  // 商品池修改
  cnnc_updateCpCommodityPools: {
    // mock: true,
    control: 'dyc/busicommon/commodity/updateCpCommodityPools'
  },
  // 商品池删除
  cnnc_deleteCpCommodityPools: {
    // mock: true,
    control: 'dyc/busicommon/commodity/deleteCpCommodityPools'
  },
  // 商品池-标签管理列表查询
  cnnc_queryCpLabelList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpLabelList'
  },
  // 商品池-标签管理列表查询-新增
  cnnc_addCpLabel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/addCpLabel'
  },
  // 商品池-标签管理列表查询-修改
  cnnc_updateCpLabel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/updateCpLabel'
  },
  // 商品池-标签管理列表查询-删除
  cnnc_deteleCpLabel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/deteleCpLabel'
  },
  // 商品池-已关联商品类型列表查询
  cnnc_queryCpRelatedCommodityTypeList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpRelatedCommodityTypeList'
  },
  // 商品池-已关联单品类型列表查询
  cnnc_queryCpRelatedSkuList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpRelatedSkuList'
  },
  // 商品池-未关联单品类型列表查询
  cnnc_queryCpNotRelateSkuList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpNotRelateSkuList'
  },
  // 商品池-未关联单品关联
  cnnc_relateCpsku: {
    // mock: true,
    control: 'dyc/busicommon/commodity/relateCpsku'
  },
  // 商品池-单品列表导入
  cnnc_importSkuRelPool: {
    // mock: true,
    control: 'dyc/busicommon/commodity/importSkuRelPool'
  },
  // 商品池-待关联商品类型列表查询
  cnnc_queryCpNotRelateCommodityTypeList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpNotRelateCommodityTypeList'
  },
  // 商品池-商品池关联商品类型
  cnnc_relateCpCommodityType: {
    // mock: true,
    control: 'dyc/busicommon/commodity/relateCpCommodityType'
  },
  // 商品池-商品池解除关联商品类型
  cnnc_dissociatedCpCommodityType: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dissociatedCpCommodityType'
  },
  // 商品池-已关联供应商列表查询
  cnnc_queryCpRelatedSupplierList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpRelatedSupplierList'
  },
  // 商品池-待关联供应商列表查询
  cnnc_queryCpNotRelateSupplierList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpNotRelateSupplierList'
  },
  // 商品池-商品池关联供应商
  cnnc_relateCpSupplier: {
    // mock: true,
    control: 'dyc/busicommon/commodity/relateCpSupplier'
  },
  // 商品池-商品池解除关联供应商
  cnnc_dissociatedCpSupplier: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dissociatedCpSupplier'
  },
  // 商品池-已关联协议列表查询
  cnnc_queryCpRelatedAgreeList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpRelatedAgreeList'
  },
  // 商品池-未关联协议列表查询
  cnnc_queryCpNotRelateAgreeList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpNotRelateAgreeList'
  },
  // 商品池-商品池关联协议
  cnnc_relateCpAgree: {
    // mock: true,
    control: 'dyc/busicommon/commodity/relateCpAgree'
  },
  // 商品池-商品池解除关联协议
  cnnc_dissociatedCpAgree: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dissociatedCpAgree'
  },
  // 商品池-已关联商品明细列表查询
  cnnc_queryCpRelatedCommodityList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpRelatedCommodityList'
  },
  // 商品池-未关联商品明细列表查询
  cnnc_queryCpNotRelateCommodityList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpNotRelateCommodityList'
  },
  // 商品池-商品池关联商品明细
  cnnc_relateCpCommodity: {
    // mock: true,
    control: 'dyc/busicommon/commodity/relateCpCommodity'
  },
  // 商品池-商品池解除关联商品明细
  cnnc_dissociatedCpCommodity: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dissociatedCpCommodity'
  },
  // 商品池-供应商列表查询
  cnnc_qryVendorList: {
    // mock: true,
    control: 'dyc/mall/commodity/qryVendorList'
  },
  // 商品池-商品品牌下拉搜索
  dyc_qeueryDropDownBrandSearch: {
    // mock: true,
    control: 'dyc/busicommon/commodity/qeueryDropDownBrandSearch'
  },
  // 商品池-维护关联标签查询
  cnnc_queryCpRelatedLabelList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpRelatedLabelList'
  },
  // 商品池-维护待关联标签查询
  cnnc_queryCpNotRelateLabelList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryCpNotRelateLabelList'
  },
  // 商品池-提交关联标签
  cnnc_relateCpLabel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/relateCpLabel'
  },
  // 商品池-解除关联标签
  cnnc_dissociatedCpLabel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dissociatedCpLabel'
  },
  // 获取商品、单品属性
  dyc_getCommoditytypeAttrInfo: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getCommoditytypeAttrInfo'
  },
  // 协议商品获取商品、单品属性
  dyc_getSpuManagementListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSpuManagementListQry'
  },
  // 协议商品创建商品
  dyc_dealDycAgrSpuCreate: {
    // mock: true,
    control: 'dyc/zone/commodity/dealDycAgrSpuCreate'
  },
  // 商品审批批量提交校验
  dyc_dealSubCheck: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSubCheck'
  },
  // 商品审批批量提交校验
  dyc_dealAgrGoodsinbulktosubmit: {
    // mock: true,
    control: 'dyc/zone/commodity/dealAgrGoodsinbulktosubmit'
  },
  // 协议单品批量上架
  dyc_dealDycPutOnSelf: {
    // mock: true,
    control: 'dyc/zone/commodity/dealDycPutOnSelf'
  },
  // 单品批量下架
  dyc_dealAgrOffShelfApply: {
    // mock: true,
    control: 'dyc/zone/commodity/dealAgrOffShelfApply'
  },
  // 协议单品强制下架
  dyc_dealAgrskuOffShlef: {
    // mock: true,
    control: 'dyc/zone/commodity/dealAgrskuOffShlef'
  },
  // 协议单品恢复上架
  dyc_dealAgrBackonApply: {
    // mock: true,
    control: 'dyc/zone/commodity/dealAgrBackonApply'
  },
  // 修改商品---保存/提交单品
  dyc_dealSpuManagingeditor: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSpuManagingeditor'
  },
  // 修改单品---保存/提交单品
  dyc_dealSkuEditor: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSkuEditor'
  },
  // 单品详情，查询商品图片
  dyc_uccSpuImageQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/uccSpuImageQry'
  },
  // 商品新增、编辑，查看属性记录
  dyc_getSupplierAttrRecord: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSupplierAttrRecord'
  },
  // 商品类型下拉框
  dyc_queryDropCommdType: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryDropCommdType'
  },
  // 供应商下拉框
  cnnc_queryVendor: {
    // mock: true,
    control: 'dyc/estore/commodity/noauth/queryVendor'
  },
  // 无协议商品批量提交
  selfrun_dealSelfSpuThebatchfile: {
    // mock: true,
    control: 'dyc/selfrun/commodity/dealSelfSpuThebatchfile'
  },
  // 无协议商品批量上架
  selfrun_dealPutOnSelf: {
    // mock: true,
    control: 'dyc/selfrun/commodity/dealPutOnSelf'
  },
  // 无协议商品批量下架
  selfrun_dealOffShelfApply: {
    // mock: true,
    control: 'dyc/selfrun/commodity/dealOffShelfApply'
  },
  // 无协议商品强制下架
  selfrun_dealSelfSkuEnforceDown: {
    // mock: true,
    control: 'dyc/selfrun/commodity/dealSelfSkuEnforceDown'
  },
  // 无协议商品恢复上架
  selfrun_dealSelfBackonApply: {
    // mock: true,
    control: 'dyc/selfrun/commodity/dealSelfBackonApply'
  },
  // 物料分页查询
  common_dealDycUccMaterialcodesearch: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccMaterialcodesearch'
  },
  // 计划关联查询
  common_getPurchaseplan: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getPurchaseplan'
  },
  // 无协议商品创建
  selfrun_dealCreateSpu: {
    // mock: true,
    control: 'dyc/selfrun/commodity/dealCreateSpu'
  },
  // 查询频道搜索订单
  dyc_getChannelSearchOrder: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getChannelSearchOrder'
  },
  // 商品管理参数
  dyc_getMeasuringunitQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getMeasuringunitQry'
  },
  // 计量单位列表查询
  dyc_getMeasuringunitListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getMeasuringunitListQry'
  },
  // 计量单位修改
  dyc_editMeasure: {
    // mock: true,
    control: 'dyc/busicommon/commodity/editMeasure'
  },
  // 商品心频道综合排序详情查询
  dyc_getSearchOrderInfo: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSearchOrderInfo'
  },
  // 商品中心频道综合排序参数新增
  dyc_dealChannelSearchOrderAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealChannelSearchOrderAdd'
  },
  // 商品中心频道综合排序修改API
  dyc_dealChannelSearchOrderEdit: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealChannelSearchOrderEdit'
  },
  // 商品中心频道综合排序修改API
  dyc_getNoRealChannel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getNoRealChannel'
  },
  // 商品中心频道综合排序删除API
  dyc_deleteChannelSearchOrder: {
    // mock: true,
    control: 'dyc/busicommon/commodity/deleteChannelSearchOrder'
  },
  // 商品中心配置参数删除API
  dyc_deleteparametersQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/deleteparametersQry'
  },
  // 商品中心配置参数新增
  dyc_dealDycUccConfigurationparametersAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccConfigurationparametersAdd'
  },
  // 无协议商品删除
  selfrun_deleteGoods: {
    // mock: true,
    control: 'dyc/selfrun/commodity/deleteGoods'
  },
  // 商品详情单品规格
  dyc_getSpuDetailSkuList2: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/getSpuDetailSkuList'
  },
  // 修改商品时，获取单品数据
  common_getSpuEditDetailSkuList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSpuEditDetailSkuList'
  },
  // 获取上一级物料分类
  common_getCatalogPath: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getCatalogPath'
  },
  // 商品属性关联排序修改API
  common_dealUccRelDefShowOrderEdit: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealUccRelDefShowOrderEdit'
  },
  // 超市单品区间价格预警配置查询API
  dyc_qryIntervalPricePercentage: {
    // mock: true,
    control: 'dyc/estore/commodity/qryIntervalPricePercentage'
  },
  // 超市单品周期预警配置更新API
  dyc_updateCyclePircePercentage: {
    // mock: true,
    control: 'dyc/estore/commodity/updateCyclePircePercentage'
  },
  // 商品管理-电商商品管理列表查询
  dyc_getEstoreSkuManagementListQry: {
    // mock: true,
    control: 'dyc/estore/commodity/getEstoreSkuManagementListQry'
  },
  // 超市应用-超市单品区间价格预警修改API
  dyc_dealDycIntervalPricePercentage: {
    // mock: true,
    control: 'dyc/estore/commodity/dealDycIntervalPricePercentage'
  },
  // 商品管理-电商商品管理-待关联批量提交
  dyc_dealDycSkuRelateMadSubmit: {
    // mock: true,
    control: 'dyc/estore/commodity/dealDycSkuRelateMadSubmit'
  },
  // 商品管理-电商商品管理-批量上架
  estore_dealDycPutOnSelf: {
    // mock: true,
    control: 'dyc/estore/commodity/dealDycPutOnSelf'
  },
  // 商品管理-电商商品管理-关联物料
  estore_dealDycUccItemassociatedmaterials: {
    // mock: true,
    control: 'dyc/estore/commodity/dealDycUccItemassociatedmaterials'
  },
  // 商品管理-电商商品上架审批-通过
  estore_dealDyconShlefApproval: {
    // mock: true,
    control: 'dyc/estore/commodity/dealDyconShlefApproval'
  },
  // 商品管理-转交
  estore_skuApprovelTransfer: {
    // mock: true,
    control: 'dyc/busicommon/commodity/skuApprovelTransfer'
  },
  // 商品管理-加签
  estore_skuApprovelJoinSign: {
    // mock: true,
    control: 'dyc/busicommon/commodity/skuApprovelJoinSign'
  },
  // 商品管理-校验任务是否为加签任务
  estore_checkJoinTask: {
    // mock: true,
    control: 'dyc/busicommon/commodity/checkJoinTask'
  },
  // 商品管理-传阅
  estore_dealTransferRead: {
    // mock: true,
    control: 'dyc/self/order/dealTransferRead'
  },
  // 完成审批环节信息查询
  estore_qryApproveStepList: {
    // mock: true,
    control: 'dyc/self/order/qryApproveStepList'
  },
  // 商品管理-电商商品下架审批-通过
  estore_dealDycOffShelfApproval: {
    // mock: true,
    control: 'dyc/estore/commodity/dealDycOffShelfApproval'
  },
  // 商品管理-电商商品恢复上架审批-通过
  estore_dealDycbackshelfforapproval: {
    // mock: true,
    control: 'dyc/estore/commodity/dealDycbackshelfforapproval'
  },
  // 商品管理-电商商品管理-批量下架
  estore_dealDycOffShelf: {
    // mock: true,
    control: 'dyc/estore/commodity/dealDycOffShelf'
  },
  // 商品管理-电商商品管理-恢复上架
  estore_dealEstoreIteminbulkforrecovery: {
    // mock: true,
    control: 'dyc/estore/commodity/dealEstoreIteminbulkforrecovery'
  },
  // 商品管理-电商商品加价管理-商品类型加价
  estore_getCommoditytypepriceListQry: {
    // mock: true,
    control: 'dyc/estore/commodity/getCommoditytypepriceListQry'
  },
  // 商品管理-电商商品加价管理-单品加价
  estore_querySkuAddPriceList: {
    // mock: true,
    control: 'dyc/estore/commodity/querySkuAddPriceList'
  },
  // 商品管理-电商商品加价管理-商品类型加价查看-历史调价记录
  estore_qryCoefficientLog: {
    // mock: true,
    control: 'dyc/estore/commodity/qryCoefficientLog'
  },
  // 商品管理-电商商品加价管理-单品加价查看-历史调价记录
  estore_querySkuAddPriceLogList: {
    // mock: true,
    control: 'dyc/estore/commodity/querySkuAddPriceLogList'
  },
  // 商品管理-电商商品加价管理-单品加价批量删除
  estore_batchDeleteSkuAddPrice: {
    // mock: true,
    control: 'dyc/estore/commodity/batchDeleteSkuAddPrice'
  },
  // 商品管理-电商商品加价管理-单品加价批量删除
  estore_dealUccCommoditytypepriceDelete: {
    // mock: true,
    control: 'dyc/estore/commodity/dealUccCommoditytypepriceDelete'
  },
  // 商品管理-电商商品加价管理-商品类型加价修改
  estore_dealCommoditytypepriceEdit: {
    // mock: true,
    control: 'dyc/estore/commodity/dealCommoditytypepriceEdit'
  },
  // 商品管理-电商商品加价管理-单品加价修改
  estore_batchUpdateSkuAddPrice: {
    // mock: true,
    control: 'dyc/estore/commodity/batchUpdateSkuAddPrice'
  },
  // 商品管理-价格预警记录列表查询
  dyc_getDycUccPricesearlywarningrecordListQry: {
    // mock: true,
    control: 'dyc/estore/commodity/getDycUccPricesearlywarningrecordListQry'
  },
  // 商品管理-超市价格变动记录列表查询
  dyc_getDycUccPricechangerecordListQry: {
    // mock: true,
    control: 'dyc/estore/commodity/getDycUccPricechangerecordListQry'
  },
  // 商品管理-价格变动记录列表查询
  dyc_getSkuPricechangerecordListQry: {
    // mock: true,
    control: 'dyc/estore/commodity/getSkuPricechangerecordListQry'
  },
  // 商品管理-商品加价管理-未加价的单品列表
  estore_getNotAddSkuAddPriceList: {
    // mock: true,
    control: 'dyc/estore/commodity/getNotAddSkuAddPriceList'
  },
  // 商品管理-商品加价管理-未加价的单品列表-设置加价系数
  estore_batchInsertAddCoefficient: {
    // mock: true,
    control: 'dyc/estore/commodity/batchInsertAddCoefficient'
  },
  // 公共应用-获取Ftp服务器文件目录API
  estore_listfile: {
    // mock: true,
    control: 'dyc/estore/commodity/ability/ftp/listfile'
  },
  // 无协议商品模板导入API
  selfrun_dealUccSpuImport: {
    // mock: true,
    control: 'dyc/selfrun/commodity/dealUccSpuImport'
  },
  // 公共应用-商品图片校验API
  common_dealUccSpuImagevalidation: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealUccSpuImagevalidation'
  },
  // 自营应用-无协议商品模板导出API
  selfrun_getSelfTemplateExport: {
    // mock: true,
    control: 'dyc/selfrun/commodity/getSelfTemplateExport'
  },
  // 专区应用-专区商品模板导出API
  selfrun_dealDycUccThezoneSpuThetemplateexport: {
    // mock: true,
    control: 'dyc/zone/commodity/dealDycUccThezoneSpuThetemplateexport'
  },
  // 专区应用-专区商品模板导入创建API
  zone_dealDycUccThezoneSpuImporttemplatetocreate: {
    // mock: true,
    control: 'dyc/zone/commodity/dealDycUccThezoneSpuImporttemplatetocreate'
  },
  // 专区应用-专区商品模板导入创建API
  zone_commodityQueryAgreementSku: {
    // mock: true,
    control: 'dyc/zone/agreement/commodityQueryAgreementSku'
  },
  // 商品管理-类目维护管理
  estore_qrySearchGuideCatalogRelGroupList: {
    // mock: true,
    control: '/dyc/estore/search/qrySearchGuideCatalogRelGroupList'
  },
  // 商品管理-类目维护管理-删除关联
  estore_deleteSearchGuideCatalogRel: {
    // mock: true,
    control: '/dyc/estore/search/deleteSearchGuideCatalogRel'
  },
  // 商品管理-类目维护管理-查询三级类目
  estore_qrySearchGuideCatalogRelCanAddCatalogList: {
    // mock: true,
    control: '/dyc/estore/search/qrySearchGuideCatalogRelCanAddCatalogList'
  },
  // 商品管理-类目维护管理-查看/修改三级类目
  estore_qrySearchGuideCatalogRelList: {
    // mock: true,
    control: '/dyc/estore/search/qrySearchGuideCatalogRelList'
  },
  // 商品管理-类目维护管理-新增/修改三级类目
  estore_updateSearchGuideCatalogRel: {
    // mock: true,
    control: '/dyc/estore/search/updateSearchGuideCatalogRel'
  },
  // 商品管理-分词管理-分词列表查询
  commodity_querySeInitDicListPage: {
    // mock: true,
    control: 'dyc/mall/participle/querySeInitDicListPage'
  },
  // 商品管理-分词管理-分词下拉框查询
  commodity_querySeInitDicTypeList: {
    // mock: true,
    control: 'dyc/mall/participle/querySeInitDicTypeList'
  },
  // 商品管理-分词管理-分词新增
  commodity_addSeInitDic: {
    // mock: true,
    control: 'dyc/mall/participle/addSeInitDic'
  },
  // 商品管理-分词管理-分词删除
  commodity_deleteSeInitDic: {
    // mock: true,
    control: 'dyc/mall/participle/deleteSeInitDic'
  },
  // 商品管理-分词管理-分词更新
  commodity_updateSeInitDic: {
    // mock: true,
    control: 'dyc/mall/participle/updateSeInitDic'
  },
  // 商品管理-分词管理-分词同步
  commodity_rewriteFile: {
    // mock: true,
    control: 'dyc/mall/participle/rewriteFile'
  },
  // 商品管理-分词管理-同义词列表查询
  commodity_querySeCorrectionListPage: {
    // mock: true,
    control: 'dyc/mall/synonym/querySeCorrectionListPage'
  },
  // 商品管理-分词管理-同义词下拉框查询
  commodity_querySeCorrectionTypeList: {
    // mock: true,
    control: 'dyc/mall/synonym/querySeCorrectionTypeList'
  },
  // 商品管理-分词管理-同义词新增
  commodity_addSeCorrection: {
    // mock: true,
    control: 'dyc/mall/synonym/addSeCorrection'
  },
  // 商品管理-分词管理-同义词删除
  commodity_deleteSeCorrection: {
    // mock: true,
    control: 'dyc/mall/synonym/deleteSeCorrection'
  },
  // 商品管理-分词管理-同义词更新
  commodity_updateSeCorrection: {
    // mock: true,
    control: 'dyc/mall/synonym/updateSeCorrection'
  },
  // 商品管理-分词管理-同义词同步
  commodity_reSewriteFile: {
    // mock: true,
    control: '/dyc/mall/synonym/rewriteFile'
  },
  // 商品管理-商品ES数据迁移-进度查询
  commodity_getSyncProgress: {
    // mock: true,
    control: 'dyc/estore/commodity/getSyncProgress'
  },
  // 未登录可查询是否一物一码
  commodity_noauthGetparametersDetail: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/getparametersDetail'
  },
  // 查询物料分类
  commodity_queryIdenticalCatalogList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryIdenticalCatalogList'
  },
  // 查询商品名称列表
  commodity_queryGoodsSupplierforDrop: {
    // mock: true,
    control: 'dyc/supplier/queryGoodsSupplierforDrop'
  },
  // 添加例外
  commodity_commdTypeAddCoefficient: {
    // mock: true,
    control: 'dyc/estore/commodity/commdTypeAddCoefficient'
  },
  // 审批接口(通过、驳回)
  pes_dealOrderAudit: {
    // mock: true,
    control: 'dyc/saas/self/order/dealOrderAudit'
  },
  // 审批接口(驳回)
  pes_dealRuTask: {
    // mock: true,
    control: 'dyc/saas/self/order/dealRuTask'
  },
  // 审批接口(转交)
  pes_dealTransferTask: {
    // mock: true,
    control: 'dyc/saas/self/dealTransferTask'
  },
  // 审批接口(前加签)
  pes_dealJoinSignTask: {
    // mock: true,
    control: 'dyc/saas/self/dealJoinSignTask'
  },
  // 审批接口(传阅)
  pes_dealTransferRead: {
    // mock: true,
    control: 'dyc/self/order/dealTransferRead'
  },
  // 审批操作历史列表接口
  pes_queryOperationRecordsList: {
    // mock: true,
    control: 'dyc/saas/audit/queryOperationRecordsList'
  },
  // 商品池导入
  pes_commodityPoolSpuImport: {
    // mock: true,
    control: 'dyc/busicommon/commodity/commodityPoolSpuImport'
  },
  // 图片批量导入
  pes_batchImageImportChange: {
    // mock: true,
    control: 'dyc/busicommon/commodity/batchImageImportChange'
  },
  // 日志列表
  pes_importLogList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/importLogList'
  },
  // 日志详情
  pes_importLogDetailList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/importLogDetailList'
  },
  // 批量导入
  pes_skuAddPriceImport: {
    // mock: true,
    control: 'dyc/selfrun/commodity/skuAddPriceImport'
  },
  // 批量导入
  ld_queryOperationRecordsList: {
    // mock: true,
    control: 'dyc/saas/audit/queryOperationRecordsList'
  },
  // 商品开发经理列表
  pes_guideManagerList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/guideManagerList'
  },
  // 商品开发经理维护新增
  pes_guideManagerAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/guideManagerAdd'
  },
  // 查询开发经理
  pes_qryUserInfoListPage: {
    // mock: true,
    control: 'dyc/saas/common/user/qryUserInfoListPage'
  },
  // 删除开发经理
  pes_guideManagerDelete: {
    // mock: true,
    control: 'dyc/busicommon/commodity/guideManagerDelete'
  },
  // 更改开发经理
  pes_guideManagerUpdate: {
    // mock: true,
    control: 'dyc/busicommon/commodity/guideManagerUpdate'
  },
  // 开发经理导入
  pes_guideManagerImport: {
    // mock: true,
    control: 'dyc/busicommon/commodity/guideManagerImport'
  },
  // 商城链接列表查询
  pes_managerLinkUrlList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/managerLinkUrlList'
  },
  // // 导入商城链接列表
  pes_importManagerLinkUrl: {
    // mock: true,
    control: 'dyc/busicommon/commodity/importManagerLinkUrl'
  },
  // // 类目查询
  pes_getDycUccCategoryatthefrontdeskQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getDycUccCategoryatthefrontdeskQry'
  },
  // 商品类型
  pes_qrySupSignItemList: {
    // mock: true,
    control: 'dyc/saas/common/user/qrySupSignItemList'
  },
  // 品商分离协议已创建商品列表API
  pes_getSpuManagementListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSpuManagementListQry'
  },
  // 品商分离计算API
  pes_priceCalculate: {
    // mock: true,
    control: 'dyc/zone/commodity/priceCalculate'
  },
  // 加价比率导入
  pes_priceCalculateImport: {
    // mock: true,
    control: 'dyc/zone/commodity/priceCalculateImport'
  },
  // 三级类目
  pes_dealDycUccMaterialclassificationsearch: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccMaterialclassificationsearch'
  },
  // 三级类目名称
  pes_queryTypeBySku: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryTypeBySku'
  },
  // 导出模板
  pes_dealAgrSpuTemplateExportNew: {
    // mock: true,
    control: 'dyc/zone/commodity/dealAgrSpuTemplateExportNew'
  },
  // 导入模板
  pes_dealUccTheZoneSpuImportTemplateCreate: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealUccTheZoneSpuImportTemplateCreate'
  },
  // 商品删除
  pes_commodityDeleteGoods: {
    // mock: true,
    control: 'dyc/selfrun/commodity/deleteGoods'
  },
  // 商品批量描述提交
  pes_commodityBatchRemarkImport: {
    // mock: true,
    control: 'dyc/busicommon/commodity/batchRemarkImport'
  },
  // 商品品牌列表搜索
  pes_commodityQryBrandList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/qryBrandList'
  },
  // 单品批量修改
  pes_uccSkuImportTemplateUpdateBatch: {
    // mock: true,
    control: '/dyc/busicommon/commodity/uccSkuImportTemplateUpdateBatch'
  },
  // 单品批量修改 对应的 批量导出
  pes_dealSkuTemplateExport: {
    // mock: true,
    control: 'dyc/zone/commodity/dealSkuTemplateExport'
  },
  // 导出批量修改模板
  pes_dealSkuTemplateDownload: {
    // mock: true,
    control: 'dyc/sku/singleItem/dealSkuTemplateDownload'
  },
  // 查询后台分类集合（不分页）
  pes_qryEMdmCatalog: {
    control: 'dyc/busicommon/commodity/qryEMdmCatalog'
  },
  // 分类查询下拉搜索条件(条件查询)
  pes_qryPageEMdmCatalog: {
    control: 'dyc/busicommon/commodity/qryPageEMdmCatalog'
  },
  // 新增/编辑后台分类
  pes_writeEMdmCatalog: {
    control: 'dyc/busicommon/commodity/writeEMdmCatalog'
  },
  // 根据三级分类查询属性
  pes_qryPropListByCatalogId: {
    control: 'dyc/busicommon/commodity/qryPropListByCatalogId'
  },
  // 查询所有属性（分页）
  pes_qryPropPageList: {
    control: 'dyc/busicommon/commodity/qryPropPageList'
  },
  // 修改三级分类下属性字段
  pes_updatePropByCatalog: {
    control: 'dyc/busicommon/commodity/updatePropByCatalog'
  },
  // 属性复制-条件查询分类下所有属性
  pes_qryPropPageListByCatalog: {
    control: 'dyc/busicommon/commodity/qryPropPageListByCatalog'
  },
  // 属性复制
  pes_copyBathPropFromCatalog: {
    control: 'dyc/busicommon/commodity/copyBathPropFromCatalog'
  },
  // 属性维护
  pes_addAndDelBathPropCatalog: {
    control: 'dyc/busicommon/commodity/addAndDelBathPropCatalog'
  },
  // 属性删除
  pes_deletePropByCatalog: {
    control: 'dyc/busicommon/commodity/deletePropByCatalog'
  },
  // 单品批量新增
  pes_uccBatchSkuImportTemplateCreate: {
    control: 'dyc/busicommon/commodity/dealUccTheZoneBatchSkuImportTemplateCreate'
  },
  // 导出批量新增模板
  pes_dealAgrSkuTemplateBatchExport: {
    control: 'dyc/zone/commodity/dealAgrSkuTemplateBatchExport'
  },
  // 商品管理-商品分类
  commodity_getDropCommdType: {
    control: 'dyc/busicommon/commodity/qryEMdmCatalog'
  },
  // 商品管理-新建商品/重复性、相似性校验
  commodity_addSku: {
    control: 'dyc/busicommon/commodity/saveSku'
  },
  // 商品管理-获取商品数据
  commodity_getQuerySkuList: {
    // control:'dyc/zone/commodity/getQuerySkuList'
    control: 'dyc/busicommon/commodity/qryAllCommoditySkuPage'
  },
  // 商品管理-获取采购数据
  commodity_getSkuManagementListInfo: {
    control: 'dyc/zone/commodity/getSkuSupplyManagementListInfo'
  },
  // 商品管理-批量启用
  commodity_skuSkuenable: {
    control: 'dyc/mall/skustatus/noauth/skuSkuenable'
  },
  // 商品管理-商品-批量禁用
  commodity_skuSkuNoenable: {
    control: 'dyc/mall/skustatus/noauth/skuSkuNoenable'
  },
  // 商品管理-商品-批量上架
  commodity_skueShelve: {
    control: 'dyc/mall/skustatus/noauth/skueShelve'
  },
  // 商品管理-商品-批量上架
  commodity_skuSkuDown: {
    control: 'dyc/mall/skustatus/noauth/skuSkuDown'
  },
  // 商品管理-采购信息状态-启用
  commodity_updateSupply: {
    control: 'dyc/busicommon/commodity/sku/updateSupply'
  },
  // 商品管理-采购信息状态-禁用
  commodity_deleteSupply: {
    control: 'dyc/busicommon/commodity/sku/supply/updateState'
  },
  // 商品管理-编辑-获取采购全量数据
  commodity_getSupplyData: {
    control: 'dyc/busicommon/commodity/sku/supply/edit/info'
  },
  // 商品管理-编辑-获取商品全量数据
  commodity_edit_getSku: {
    control: 'dyc/busicommon/commodity/sku/edit/getSku'
  },
  // 商品管理-根据三级分类ID查询属性
  commodity_qryPropListByCatalogId: {
    control: 'dyc/busicommon/commodity/qryPropListByCatalogId'
  },
  // 商品管理-编辑商品
  commodity_editSku: {
    control: 'dyc/busicommon/commodity/editSku'
  },
  // 商品管理-编辑图片
  commodity_emitImg: {
    control: 'dyc/busicommon/commodity/emitImg'
  },
  // 商品管理-编辑采购信息
  commodity_editSupply: {
    control: 'dyc/busicommon/commodity/sku/editSupply'
  },
  // 商品管理-编辑描述信息
  commodity_descriptionEmit: {
    control: 'dyc/busicommon/commodity/descriptionEmit'
  },
  // 商品管理-编辑技术属性
  commodity_emitSkuAttribute: {
    control: 'dyc/busicommon/commodity/emitSkuAttribute'
  },
  // 商品管理-新建采购信息
  commodity_addSupply: {
    control: 'dyc/busicommon/commodity/sku/addSupply'
  },
  // 商品管理-采购信息-获取单品基本信息依据skuCode
  commodity_getSkuBaseInfoByCode: {
    control: 'dyc/busicommon/commodity/sku/supply/getSkuBaseInfoByCode'
  },
  // 商品管理-批量导出
  commodity_skuSupplyInfoExport: {
    control: 'dyc/busicommon/commodity/skuSupplyInfoExport'
  },
  // 商品管理-技术属性-分类查询技术属性列表
  commodity_qryCatalogSkuSpecPageListByCatalog: {
    control: 'dyc/busicommon/commodity/qryCatalogSkuSpecPageListByCatalog'
  },
  // 商品管理-批量新增采购信息
  commodity_addSupplyBatchByExcel: {
    control: 'dyc/busicommon/commodity/sku/addSupplyBatchByExcel'
  },
  // 商品管理-批量编辑采购信息
  commodity_editSupplyBatchByExcel: {
    control: '/dyc/busicommon/commodity/sku/addOrEditSupplyBatchByExcel'
  },
  // 商品管理-批量修改采购价格
  commodity_skuSupplyPriceBatchUpdate: {
    control: 'dyc/busicommon/commodity/skuSupplyPriceBatchUpdate'
  },
  // 商品管理-批量导出sku编码
  commodity_skuTemplateBatchExport: {
    control: 'dyc/busicommon/commodity/skuTemplateBatchExport'
  },
  // 商品管理-批量维护sku描述
  commodity_skuDescTemplateBatchImport: {
    control: 'dyc/busicommon/commodity/skuDescTemplateBatchImport'
  },
  // 商品管理-批量维护sku描述
  commodity_skuImgTemplateBatchImport: {
    control: 'dyc/busicommon/commodity/skuImgTemplateBatchImport'
  },
  // 商品管理-批量修改sku
  commodity_uccSkuImportTemplateUpdateBatch: {
    control: 'dyc/busicommon/commodity/uccSkuImportTemplateUpdateBatch'
  },
  // 商品管理-批量修改sku销售价
  commodity_skuSalePriceBatchUpdate: {
    control: 'dyc/busicommon/commodity/skuSalePriceBatchUpdate'
  },
  // 商品管理-可修改商品信息导出
  commodity_skuBathUpdateExport: {
    control: 'dyc/busicommon/commodity/skuInfoBathExport'
  },
  // 商品管理-商品销售价导出
  commodity_skuSalePriceBathUpdateExport: {
    control: 'dyc/busicommon/commodity/skuSalePriceBathUpdateExport'
  },
  // 商品管理-商品属性-根据三级id导出规格
  commodity_exportSkuSpecExcelByCatalogId: {
    control: 'dyc/busicommon/commodity/exportSkuSpecExcelByCatalogId'
  },
  // 商品管理-商品属性-属性回显
  commodity_getSkuAttributeInfo: {
    control: 'dyc/busicommon/commodity/getSkuAttributeInfo'
  },
  // 商品管理-批量修改售价-模板下载
  commodity_skuSalePriceTemplateBatchExport: {
    control: 'dyc/busicommon/commodity/skuSalePriceTemplateBatchExport'
  },
  // 商品管理-批量修改采购价-模板下载
  commodity_skuSupplyPriceTemplateBatchExport: {
    control: 'dyc/busicommon/commodity/skuSupplyPriceTemplateBatchExport'
  },
  // 商品管理-技术属性-文件导入
  commodity_uccBatchSkuSpecExport: {
    control: 'dyc/busicommon/commodity/uccBatchSkuSpecExport'
  },
  // 全部单品-导入记录查询
  pes_qryPageFileImpLog: {
    // mock: true,
    control: '/dyc/busicommon/commodity/qryPageFileImpLog'
  },
  // 商品管理-商品分类属性-导出
  commodity_exportSkuAttrExport: {
    // mock: true,
    control: 'dyc/busicommon/commodity/exportSkuAttrExport'
  },
  // 商品管理-商品分类属性-导出
  commodity_dealUccBatchSkuImportTemplateCreate: {
    control: 'dyc/busicommon/commodity/dealUccBatchSkuImportTemplateCreate'
  },
  // 商品管理-商品分类属性-供应商查询
  commodity_qryMerchantListPage: {
    control: 'metaData/liandongMember/dycUmcMerchantQryListPageService/auto0006/qryMerchantListPage'
  },
  // 商品管理-商品批量新增-模板下载
  commodity_dealAgrSkuTemplateBatchExport: {
    control: 'dyc/zone/commodity/dealAgrSkuTemplateBatchExport'
  },
  // 商品管理-批量上下架
  commodity_batchUpdateStatus: {
    control: 'dyc/mall/sku/batch/updateStatus'
  },
  // 商品管理-批量启用禁用
  commodity_batchUpdateState: {
    control: 'dyc/mall/sku/batch/updateState'
  },
  // 卖家-供应商采购信息导出
  commodity_sellerSkuSupplyInfoExport: {
    control: 'dyc/busicommon/commodity/sellerSkuSupplyInfoExport'
  },
  // 卖家-标准商品管理-批量维护
  commodity_addOrEditSupplyBatchByExcel: {
    control: 'dyc/busicommon/commodity/supplier/sku/addOrEditSupplyBatchByExcel'
  },
  // 卖家-标准商品管理-采购信息列表查询
  commodity_qrySellerSkuSupplyList: {
    control: 'dyc/busicommon/commodity/qrySellerSkuSupplyList'
  },
  // 卖家-供应商批量添加sku-列表查询
  commodity_qrySellerSkuList: {
    control: 'dyc/busicommon/commodity/qrySellerSkuList'
  },
  // 卖家-卖家用户批量新增商品
  commodity_saveSkuBatch: {
    control: '/dyc/busicommon/commodity/supplier/saveSkuBatch'
  },
  // 卖家-商品采购管理删除
  commodity_deleteSkuSupplyManagement: {
    control: '/dyc/zone/commodity/deleteSkuSupplyManagement'
  },
  // 卖家-编辑商品信息-获取采购信息
  commodity_qrySupplierSkuInfo: {
    control: '/dyc/busicommon/commodity/supplier/sku/edit/info'
  },
  // 卖家-编辑商品信息
  commodity_supplierEditSku: {
    control: '/dyc/busicommon/commodity/supplier/sku/editSku'
  },
  commodity_queryEnterpriseDetail: {
    control: 'dyc/supplier/qry/queryEnterpriseDetail'
  },
  // 卖家-获取商品信息-批量查询
  commodity_qrySkuSupplierBatch: {
    control: 'dyc/busicommon/commodity/qrySkuSupplierBatch'
  },
  // 卖家-获取商品信息-精确查询
  commodity_qrySkuSupplierList: {
    control: 'dyc/busicommon/commodity/qrySkuSupplierList'
  },
  // 卖家-商品管理-新建供应关系
  commodity_supplierAddSku: {
    control: 'dyc/busicommon/commodity/supplier/sku/addSku'
  }
};